import React from "react"
import { VictoryLine, VictoryLabel } from "victory"



const LinearRegression = ({ x_array, y_array }) => {

    // modified from https://dracoblue.net/dev/linear-least-squares-in-javascript/ //

    var sum_x = 0
    var sum_y = 0
    var sum_xy = 0
    var sum_xx = 0
    var sum_yy = 0
    var count = 0

    var x = 0
    var y = 0
    var values_length = x_array.length

    console.log(x_array)
    for (var v = 0; v < values_length; v++) {

        x = x_array[v]
        y = y_array[v]

        sum_x += x
        sum_y += y
        sum_xx += x*x
        sum_xy += x*y
        sum_yy += y*y
        count++

    }

    var m = (count*sum_xy - sum_x*sum_y) / (count*sum_xx - sum_x*sum_x)
    var b = (sum_y/count) - (m*sum_x)/count
    var rsq = Math.pow((count*sum_xy - sum_x*sum_y)/Math.sqrt((count*sum_xx-sum_x*sum_x)*(count*sum_yy-sum_y*sum_y)),2)

    const min_x = Math.min.apply(Math, x_array)
    const max_x = Math.max.apply(Math, x_array)

    const victoryData =[
        {'x' : min_x, 'y' : min_x*m + b, label : '',},
        {'x' : max_x, 'y' : max_x*m + b, label : ['RSQ:',Math.round(100*rsq)/100],},
    ]

    const highlight_red = '#ff4a77'

    // note, to render a victory component in a different victory chart you have to call as a func 
    // https://stackoverflow.com/questions/49269758/why-arent-victory-charts-components-composable

    if (values_length === 0) {
        return(null)
    } else {
        return(
            <VictoryLine
                data={victoryData}
                x='x'
                y='y'
                style={{
                    data: {
                        stroke: highlight_red,
                        strokeWidth: 1.5,
                        strokeDasharray: '5,5',
                        strokeOpacity: .45,
                    },
                }}
                labelComponent={
                    <VictoryLabel
                        renderInPortal={true}
                        dx={20}
                        dy={-5}
                        textAnchor="middle"
                        verticalAnchor='middle'
                        lineHeight={[1,1.5]}
                        style={[
                            {
                                fill : highlight_red,
                                fillOpacity : .55,
                                fontSize : 7, 
                            },
                            {
                                fill : highlight_red,
                                fillOpacity : .55,
                                fontSize : 12, 
                            },
                        ]}
                    />
                }
            />
        )
    }

}

export default LinearRegression